module.exports = __webpack_public_path__ + "static/img/icon_jjzd_bg@2x.e5ab78a2.png";